import { wireButtons, drawMemories, fillForm } from "./lib";

export function main(parent) {
  if (!"content" in document.createElement("template")) {
    document
      .querySelector("#memories-unsupported-message")
      .classList.remove("hidden");
  }
  wireButtons(parent);
  drawMemories(parent);
  fillForm(parent);
}